import { styled } from "@mui/material";
import { TruncateList } from "../../../layout/TruncateList/index.js";
import { editorToolbarName } from "../classes.js";
const Toolbar = styled(TruncateList, {
  name: editorToolbarName,
  slot: "Toolbar",
  overridesResolver: (_props, styles) => styles.toolbar
})(() => ({
  alignItems: "center"
}));
export {
  Toolbar
};
//# sourceMappingURL=Toolbar.js.map
